module.exports = __webpack_public_path__ + "56d87c0861178b7d7623f85fe8cbcc34.pdf";